module.exports = __webpack_public_path__ + "static/media/Lock Blue.b5f8844f.svg";